import { GITLAB_REDIRECT_URL } from "../config"

export function getRedirectURI(repo: {
    project: string,
    namespace: string,
    ref?: string,
}) {
    if(repo.namespace && repo.project) {
        return `${GITLAB_REDIRECT_URL}?project=${repo.project}&namespace=${repo.namespace}${repo.ref ? `&ref=${repo.ref}` : ''}`
    } else {
        return GITLAB_REDIRECT_URL
    }
}
